import React, { useState, useEffect, useRef, useMemo } from 'react';
import PropTypes from 'prop-types';
import MultiSelect from '@kenshooui/react-multi-select';
import CheckboxSearch from './components/CheckboxSearch';
import '@kenshooui/react-multi-select/dist/style.css';

import CheckboxSelectItem from 'components/CheckboxMultiSelect/components/CheckboxSelectItem';

import './styles.css';

const CheckboxMultiSelect = props => {
  const {
    disabled,
    name,
    selectedItems,
    placeholder,
    groups,
    label,
    required,
    labelStyles,
    wrapperStyles,
    isValid = true,
    isLast,
    onBlur,
    onChange,
    controlFuncOptions,
    showSearch = false,
  } = props;

  const node = useRef();

  const [showOptions, setShowOptions] = useState(false);

  useEffect(() => {
    document.addEventListener('click', handleClickOutside);
    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  });

  const handleChange = selectedItems => {
    if (onChange && typeof onChange === 'function') {
      onChange(name, selectedItems.length === 0 ? null : selectedItems);
    }
  };

  const handleOptionsToggle = () => {
    if (disabled) {
      return;
    }
    if (controlFuncOptions) {
      controlFuncOptions(!showOptions);
      setShowOptions(!showOptions);
    } else {
      setShowOptions(!showOptions);
    }
  };

  const handleClickOutside = e => {
    const isOutsideClick = !node.current.contains(e.target);
    if (showOptions && isOutsideClick) {
      if (typeof onBlur === 'function') {
        onBlur(name, true, true);
      }

      handleOptionsToggle();
    }
  };

  const isRequired = required
    ? 'checkbox-multiselect__label-text checkbox-multiselect__label-text--required'
    : 'checkbox-multiselect__label-text';

  const items = useMemo(
    () =>
      props.items.map(item =>
        !item.id && item.value ? { ...item, id: item.value } : item
      ),
    [props.items]
  );

  const cls =
    (isValid
      ? 'checkbox-multiselect__placeholder'
      : 'checkbox-multiselect__placeholder checkbox-multiselect__placeholder--invalid') +
    (disabled ? ' checkbox-multiselect__placeholder--disabled' : '');

  return (
    <div className="checkbox-multiselect" ref={node} style={wrapperStyles}>
      {label && (
        <label className="checkbox-multiselect__label" style={labelStyles}>
          <span className={isRequired}>{label}</span>
        </label>
      )}

      <div className={cls} onClick={handleOptionsToggle}>
        <span className="checkbox-multiselect__selection">
          {selectedItems && selectedItems.length > 0
            ? selectedItems.map(item => item.label).join(', ')
            : placeholder}
        </span>

        <div
          aria-hidden="true"
          className="checkbox-multiselect__dropdown-indicator"
        >
          <svg
            height="20"
            width="20"
            viewBox="0 0 20 20"
            aria-hidden="true"
            focusable="false"
          >
            <path d="M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z" />
          </svg>
        </div>
      </div>

      {showOptions && (
        <div
          className={
            isLast
              ? 'checkbox-multiselect__options checkbox-multiselect__options--last'
              : 'checkbox-multiselect__options'
          }
          style={{ top: label ? '80px' : '60px' }}
        >
          <MultiSelect
            wrapperClassName="checkbox-multiselect__list"
            items={items || []}
            itemRenderer={CheckboxSelectItem}
            withGrouping={groups}
            selectedItems={selectedItems || []}
            onChange={handleChange}
            showSearch={showSearch}
            searchRenderer={CheckboxSearch}
            showSelectAll={false}
            showSelectedItems={false}
            height={210}
            responsiveHeight="210px"
          />
        </div>
      )}
    </div>
  );
};

CheckboxMultiSelect.propTypes = {
  disabled: PropTypes.bool,
  name: PropTypes.string.isRequired,
  items: PropTypes.array.isRequired,
  selectedItems: PropTypes.array,
  groups: PropTypes.bool,
  placeholder: PropTypes.string,
  label: PropTypes.string,
  required: PropTypes.bool,
  labelStyles: PropTypes.object,
  wrapperStyles: PropTypes.object,
  onChange: PropTypes.func,
  isValid: PropTypes.bool,
  onBlur: PropTypes.func,
  isLast: PropTypes.bool,
};

export default CheckboxMultiSelect;
